// extracted by mini-css-extract-plugin
export default {"linkRouter":"styles_linkRouter__uC9fI"};